// src/components/Datenschutz.js
import React from "react";
import Layout from "./../components/layout";
import "./Legal.css";

const Datenschutz = () => {
  return (
    <Layout>
      <div className="Top Bottom">
        <div className="legal-container">
          <h1 className="legal-title">Datenschutzerklärung</h1>
          <h2>Einleitung</h2>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen.
            Wir behandeln Ihre Daten vertraulich und entsprechend der
            gesetzlichen Datenschutzvorschriften sowie dieser
            Datenschutzerklärung.
          </p>
          <h2>Erfassung und Verarbeitung von Daten</h2>
          <p>
            Wir erfassen keine personenbezogenen Daten, es sei denn, Sie
            übermitteln uns diese freiwillig, z. B. über ein Kontaktformular.
            Die Nutzung unserer Website ist ohne Angabe personenbezogener Daten
            möglich.
          </p>
          <h2>Google Analytics</h2>
          <p>
            Unsere Website verwendet Google Analytics, einen Webanalysedienst
            der Google LLC ("Google"). Google Analytics verwendet sogenannte
            "Cookies", Textdateien, die auf Ihrem Computer gespeichert werden
            und die eine Analyse der Benutzung der Website durch Sie
            ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre
            Benutzung dieser Website werden in der Regel an einen Server von
            Google in den USA übertragen.
          </p>
          <p>
            Sie können die Speicherung der Cookies durch eine entsprechende
            Einstellung Ihrer Browser-Software verhindern; wir weisen jedoch
            darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
            Funktionen dieser Website vollumfänglich werden nutzen können. Sie
            können darüber hinaus die Erfassung der durch das Cookie erzeugten
            und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer
            IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch
            Google verhindern, indem Sie das unter dem folgenden Link verfügbare
            Browser-Plugin herunterladen und installieren:{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tools.google.com/dlpage/gaoptout
            </a>
          </p>
          <h2>Kontakt</h2>
          <p>
            Sollten Sie Fragen zu unseren Datenschutzpraktiken haben,
            kontaktieren Sie uns bitte unter{" "}
            <strong>
              <a href="mailto:info@q-tech.dev">Info@q-tech.dev</a>
            </strong>
            .
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default Datenschutz;
